export const a11yProps = (key, index) => {
  return {
    id: `${key}-${index}`,
    "aria-controls": `${key}panel-${index}`,
  };
};
